
import { OverlayScrollbars } from 'overlayscrollbars'
import { getUrlParamsString } from '@/lib/utils'
import 'overlayscrollbars/styles/overlayscrollbars.css'
export default {
  props: {
    title: String,
    options: Array,
    link: String,
    filterKey: String,
  },
  data() {
    return {
      open: false,
      customId: 's' + this._uid,
    }
  },
  mounted() {
    OverlayScrollbars(document.querySelector('#' + this.customId), {})
  },
  methods: {
    handleToggle() {
      this.open = !this.open
    },
    getUrlParamsString,
  },
}
